<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import flashMessage from "../../components/flashMessahe";
import ErrorMessage from "../../components/error-message";
import { ModelSelect } from 'vue-search-select';
import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  url,
  alphaNum,
} from "vuelidate/lib/validators";

export default {
  components: {
      ErrorMessage,
    Layout,
    PageHeader,
    flashMessage,
      ModelSelect
  },
  data() {
    return {
      errorMessage: "",
      title: "Admin Update",
      items: [
        {
          text: "Admin Setting",
          href: "/",
        },
        {
          text: "Update",
          active: true,
        },
      ],
      status: "not_accepted",
      checkCustom: "not_accepted",
      checked: true,
      errors: null,
      uuid: "",
      adminid: "",
        visible:false,
        message:"",
        lineError:true,
        country_list:[],
      form: {
        first_name: "",
        last_name: "",
        gender: "",
        email: "",
        country_code: "",
        country: "",
        phone_code: "",
        phone_number: "",
        password: "",
        password_confirmation: "",

      },
      submitform: false,
      submitted: false,
    };
  },
  validations: {
    form: {
      first_name: {
        required,
      },
      last_name: {
        required,
      },
      gender: {
        required,
      },
      email: {
        required,
      },
      country_code: {
        required,
      },
      country: {
        required,
      },
      phone_code: {
        required,
      },
      phone_number: {
        required,
      },
      password: {
        required,
      },
      password_confirmation: {
        required,
      },
    },
  },
  created() {
    this.uuid = this.$route.params.uuid;
  },
  mounted() {
      this.getCountryList();
    this.getAdminDetail();
  },
  methods: {
      // setCountryAndPhoneCode(event){
      //     let countries=this.country_list
      //     let i;
      //     for(i=0;i<countries.length;i++){
      //         if(countries[i].countryName==event.target.value){
      //             this.form.country_code=countries[i].countryCode;
      //             this.form.phone_code=countries[i].phoneCode;
      //         }
      //     }
      // },
      setCountryAndPhoneCode(event){
          let countries=this.country_list;
          let i;
          for(i=0;i<countries.length;i++){
              if(countries[i].countryName==event){
                  this.form.country_code=countries[i].countryCode;
                  this.form.phone_code=countries[i].phoneCode;
              }
          }
      },
      setPhoneCodeWiseCountry(event){
          let countries=this.country_list;
          let i;
          for(i=0;i<countries.length;i++){
              if(countries[i].phoneCode==event.target.value){
                  this.form.country_code=countries[i].countryCode;
                  this.form.phone_code=countries[i].phoneCode;
                  this.form.country=countries[i].countryName;
              }
          }
      },

      async getCountryList() {
          try {
              axios
                  .get("/api/country/list", {
                      params: {
                          accessToken: localStorage.getItem("access_tocken"),
                      },
                  })
                  .then((response) => {
                      if (response.status) {
                          var temp=response.data.data;

                          var i;
                          for (i=0;i<temp.length;i++){
                              temp[i].value=temp[i].countryName;
                              temp[i].text=temp[i].countryName+' ('+temp[i].countryCode+')';
                          }
                          this.country_list = temp;
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
      onClose(){
          this.visible=false;
          this.errors=null;
      },
    async getAdminDetail() {
      try {
        axios
          .post("/api/admin/profile/" + this.uuid, {
            accessToken: localStorage.getItem("access_tocken"),
          })
          .then((response) => {
            if (response.data.status) {
              var data = response.data.data;
              this.form.first_name = data.first_name;
              this.adminid = data.id;
              this.form.last_name = data.last_name;
              this.form.gender = data.gender;
              this.form.email = data.email;
              this.form.country_code = data.country_code;
              this.form.country = data.country;
              this.form.phone_code = data.phone_code;
              this.form.phone_number = data.phone_number;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    formSubmit(event) {
      this.submitted = true;
      this.$v.$touch();
      axios
        .put("/api/admin/update", {
          id: this.uuid,
          first_name: this.form.first_name,
          last_name: this.form.last_name,
          gender: this.form.gender,
          email: this.form.email,
          country_code: this.form.country_code,
          country: this.form.country,
          phone_code: this.form.phone_code,
          phone_number: this.form.phone_number,
          password: this.form.password,
          password_confirmation: this.form.password_confirmation,
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then((response) => {
          if (response.data.status) {
            this.$refs.adminForm.reset();
            this.$swal("Good job!", "Admin Updated", "success");
            this.$router.push({ name: "all_admin" });
          } else {
            var str = response.data.message;
            var jsonParse = JSON.parse(str);
            this.errorCheck(jsonParse);
          }
        })
        .catch((error) => {
          if (error.response != undefined) {
            this.errors = error.response.data.errors;
          }
        });
    },
    errorCheck(obj) {
          let a;
          a=obj.message.search('Integrity constraint violation: 1062 Duplicate entry');

          if(a!=-1){
              this.visible=true;
              this.message='email already taken';
              this.errors='email already taken by another user';
          }
       else if(obj.statusCode == 403){
            this.visible=true;
            this.lineError=false;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (obj.message !== "Token has expired") {
        this.errors = obj.message;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
    resetForm(event) {
      console.log("Reseting the form");
      event.target.reset();
    },
  },
};
</script>

<template>
  <Layout>
    <flashMessage/>
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div class="font-bold mb-4 ">
              <div v-for="(v, k) in errors" :key="k">
                <p v-for="error in v" :key="error" class="text-sm">
                  {{ error }}
                </p>
              </div>
            </div>
            <b-form class="needs-validation" ref="adminForm" @submit.prevent="formSubmit">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="required" for="first_name">First Name</label>
                    <input
                      id="first_name"
                      v-model="form.first_name"
                      name="first_name"
                      type="text"
                      class="form-control"
                      placeholder="Type First Name"
                      value="form.first_name"
                      :class="{ 'is-invalid': submitted && $v.form.first_name.$error }"
                    />
                    <div
                      v-if="submitted && $v.form.first_name.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.permission_name.required">This value is required.</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="required" for="last_name">Last Name</label>
                    <input
                      id="last_name"
                      v-model="form.last_name"
                      name="last_name"
                      type="text"
                      class="form-control"
                      placeholder="Type Last Name"
                      value="form.last_name"
                      :class="{ 'is-invalid': submitted && $v.form.last_name.$error }"
                    />
                    <div
                      v-if="submitted && $v.form.last_name.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.last_name.required">This value is required.</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label class="required" for="gender">Gender</label>
                    <select
                      id="gender"
                      name="gender"
                      v-model="form.gender"
                      class="form-control"
                      placeholder="Type Gender"
                      :class="{ 'is-invalid': submitted && $v.form.gender.$error }">
                      <option :selected="form.gender == 'male'" value="male">Male</option>
                      <option :selected="form.gender == 'female'" value="female">Female</option>
                    </select>
                    <div
                      v-if="submitted && $v.form.gender.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.gender.required">This value is required.</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="required" for="email">Email</label>
                    <input
                      id="email"
                      v-model="form.email"
                      name="email"
                      type="email"
                      class="form-control"
                      placeholder="Type Email"
                      value="form.email"
                      :class="{ 'is-invalid': submitted && $v.form.email.$error }"
                    />
                    <div
                      v-if="submitted && $v.form.email.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.email.required">This value is required.</span>
                    </div>
                  </div>
                </div>
<!--                <div class="col-md-6">-->
<!--                    <div class="form-group">-->
<!--                        <label class="required" for="country_code">Country Code</label>-->
<!--                        <select-->
<!--                            id="country_code"-->
<!--                            name="country_code"-->
<!--                            v-model="form.country_code"-->
<!--                            type="text"-->
<!--                            class="form-control"-->
<!--                            placeholder="Type permission type"-->
<!--                            value-->
<!--                            :class="{ 'is-invalid': submitted && $v.form.country_code.$error }">-->
<!--                            <option v-bind:selected="form.country_code == 'AUS'" value="AUS">AUS</option>-->
<!--                            <option v-bind:selected="form.country_code == 'BD'" value="BD">BD</option>-->
<!--                            <option v-bind:selected="form.country_code == 'DEN'" value="DEN">DEN</option>-->
<!--                            <option v-bind:selected="form.country_code == 'UK'" value="UK">UK</option>-->
<!--                            <option v-bind:selected="form.country_code == 'KSA'" value="KSA">KSA</option>-->
<!--                        </select>-->
<!--                        <div-->
<!--                            v-if="submitted && $v.form.country_code.$error"-->
<!--                            class="invalid-feedback"-->
<!--                        >-->
<!--                            <span v-if="!$v.form.country_code.required">This value is required.</span>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="col-md-6">-->
<!--                    <div class="form-group">-->
<!--                        <label class="required" for="country">Country</label>-->
<!--                        <select-->
<!--                            id="country"-->
<!--                            name="country"-->
<!--                            v-model="form.country"-->
<!--                            type="text"-->
<!--                            class="form-control"-->
<!--                            placeholder="Type permission type"-->
<!--                            value-->
<!--                            :class="{ 'is-invalid': submitted && $v.form.country.$error }">-->
<!--                            <option :selected="form.country == 'Australia'" value="Australia">Australia</option>-->
<!--                            <option :selected="form.country == 'Bangladesh'" value="Bangladesh">Bangladesh</option>-->
<!--                            <option :selected="form.country == 'Canada'" value="Canada">Canada</option>-->
<!--                            <option :selected="form.country == 'Denmark'" value="Denmark">Denmark</option>-->
<!--                            <option :selected="form.country == 'United Kingdom'" value="United Kingdom">United Kingdom</option>-->
<!--                            <option :selected="form.country == 'Saudi Arabia'" value="Saudi Arabia">Saudi Arabia</option>-->
<!--                        </select>-->
<!--                        <div-->
<!--                            v-if="submitted && $v.form.country.$error"-->
<!--                            class="invalid-feedback"-->
<!--                        >-->
<!--                            <span v-if="!$v.form.country.required">This value is required.</span>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
                  <div class="col-md-6">
                      <div class="form-group">
                          <label class="required" for="country">Country</label>
                          <model-select :options="country_list"
                                        v-model="form.country"
                                        @input="setCountryAndPhoneCode($event)"
                                        :class="{ 'is-invalid': submitted && $v.form.country.$error }"
                                        placeholder="Select Country">
                          </model-select>
                          <div
                              v-if="submitted && $v.form.country.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.country.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-6">
                      <div class="form-group">
                          <label class="required" for="phone_code">Phone Code</label>
                          <select
                              id="phone_code"
                              name="phone_code"
                              v-model="form.phone_code"
                              v-on:change="setPhoneCodeWiseCountry"
                              class="form-control"
                              placeholder="Select Phone Code"
                              :class="{ 'is-invalid': submitted && $v.form.phone_code.$error }">
                              <option v-for="(country, index) in country_list" :value="country.phoneCode"
                                      v-bind:key="index">{{ country.phoneCode }}
                              </option>
                          </select>
                          <div
                              v-if="submitted && $v.form.phone_code.$error"
                              class="invalid-feedback"
                          >
                              <span v-if="!$v.form.phone_code.required">This value is required.</span>
                          </div>
                      </div>
                  </div>
<!--                <div class="col-md-6">-->
<!--                    <div class="form-group">-->
<!--                        <label class="required" for="phone_code">Phone Code</label>-->
<!--                        <select-->
<!--                            id="phone_code"-->
<!--                            name="phone_code"-->
<!--                            v-model="form.phone_code"-->
<!--                            type="text"-->
<!--                            class="form-control"-->
<!--                            placeholder="Type permission type"-->
<!--                            value-->
<!--                            :class="{ 'is-invalid': submitted && $v.form.phone_code.$error }">-->
<!--                            <option :selected="form.phone_code == '+61'" value="+61">Australia (+61)</option>-->
<!--                            <option :selected="form.phone_code == '+880'" value="+880">Bangladesh (+880)</option>-->
<!--                            <option :selected="form.phone_code == '+1'" value="+1">Canada (+1)</option>-->
<!--                            <option :selected="form.phone_code == '+45'" value="+45">Denmark (+45)</option>-->
<!--                            <option :selected="form.phone_code == '+44'" value="+44">United Kingdom (+44)</option>-->
<!--                            <option :selected="form.phone_code == '+966'" value="+966">Saudi Arabia (+966)</option>-->
<!--                        </select>-->
<!--                        <div-->
<!--                            v-if="submitted && $v.form.phone_code.$error"-->
<!--                            class="invalid-feedback"-->
<!--                        >-->
<!--                            <span v-if="!$v.form.phone_code.required">This value is required.</span>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="required" for="phone_number">Phone Number</label>
                    <input
                      id="phone_number"
                      v-model="form.phone_number"
                      name="phone_number"
                      type="text"
                      class="form-control"
                      placeholder="Type phone number"
                      value="form.phone_number"
                      :class="{ 'is-invalid': submitted && $v.form.phone_number.$error }"
                    />
                    <div
                      v-if="submitted && $v.form.phone_number.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.phone_number.required">This value is required.</span>
                    </div>
                  </div>
                </div>
              </div>
              <button class="btn btn-primary" type="submit">Update</button>
            </b-form>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
